class QuickShop extends HTMLElement {
  constructor() {
    super();

    this.quickaddButtons = this.querySelectorAll(".quickbutton");
    this.quickshopOpen = this.closest(".quickshop__wrapper").querySelector(".open-quickshop");
    this.prodId = this.dataset.productId;
    this.prodUrl = this.dataset.productUrl;
    this.oosCountries = this.closest(".card-wrapper")?.querySelector(
      `#oosCountries-${this.prodId}`
    );
    this.oosStates = this.closest(".card-wrapper")?.querySelector(`#oosStates-${this.prodId}`);
  }

  async connectedCallback() {
    this.quickaddButtons.forEach((btn) => {
      btn.addEventListener("click", this.quickadd.bind(this, btn));
    });

    if (this.quickshopOpen) {
      this.quickshopOpen.addEventListener("click", this.setQuickshopBtn.bind(this));
    }
  }

  disableButton(tag) {
    const quickshopHTML = `
      <p class="quickshop-header">Quick Add to Cart</p>
      <div class="quickshop-buttons"></div>
      <a class="button button-full quickshop-custom-disabled" href="javascript:void(0)">${
        tag === "oos" ? "Sold Out" : "Unavailable"
      }</a>
    `;
    this.innerHTML = quickshopHTML;

    this.classList.add(tag);
  }

  quickadd(btn) {
    const variantId = parseInt(btn.dataset.variantId);

    const matchedEarlyAccessObject = earlyAccessData.find(
      (item) => item.earlyAccessVariantId == variantId
    );

    const sideCart = document.querySelector("side-cart");

    if (matchedEarlyAccessObject) {
      try {
        fetch(window.Shopify.routes.root + "cart.js")
          .then((response) => response.json())
          .then((data) => {
            const item = data.items.find(
              (item) => item.variant_id == matchedEarlyAccessObject.earlyAccessVariantId
            );

            if (item) {
              if (qtyLimitEnabled) {
                const existingHelpMessage = document.querySelector(
                  ".gating-product-qty-limit-message"
                );

                if (existingHelpMessage) {
                  existingHelpMessage.remove();
                }

                if (
                  item.quantity < matchedEarlyAccessObject.earlyAccessProductQtyLimit &&
                  matchedEarlyAccessObject.earlyAccessProductQtyLimit > 0
                ) {
                  if (variantId && !isNaN(variantId)) {
                    sideCart.addToCart(variantId);
                  }
                } else {
                  if (!existingHelpMessage) {
                    const helpMessage = document.createElement("div");
                    helpMessage.classList.add("gating-product-qty-limit-message");
                    helpMessage.innerHTML = `You can buy up to ${matchedEarlyAccessObject.earlyAccessProductQtyLimit} sets of ${matchedEarlyAccessObject.earlyAccessVariantTitle}.`;

                    const button = this.querySelector(".button.button--primary");
                    button.parentNode.insertAdjacentElement("afterend", helpMessage);
                  }
                }
              } else {
                if (variantId && !isNaN(variantId)) {
                  sideCart.addToCart(variantId);
                }
              }
            } else {
              if (variantId && !isNaN(variantId)) {
                sideCart.addToCart(variantId);
              }
            }

            return data;
          })
          .catch((error) => {
            console.error("Error:", error);
          });
      } catch (err) {
        console.error(err);
      }
    } else {
      if (variantId && !isNaN(variantId)) {
        sideCart.addToCart(variantId);
      }
    }
  }

  setQuickshopBtn() {
    this.quickshopOpen.classList.toggle("opened");
    if (window.innerWidth <= 768 && this.quickshopOpen.classList.contains("opened")) {
      this.classList.toggle("custom-mobile-quickshop-open");
    } else if (window.innerWidth <= 768 && !this.quickshopOpen.classList.contains("opened")) {
      this.classList.toggle("custom-mobile-quickshop-open");
    }
  }
}

customElements.define("quick-shop", QuickShop);
